import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-react';

// デフォルト翻訳をロード
I18n.putVocabularies(translations);

// 最初に日本語に設定
I18n.setLanguage('ja');

// 必要な翻訳を上書き（例として一部のキーのみ）
I18n.putVocabularies({
  ja: {
    'Sign In': 'ログイン',
    'Sign Up': '会員登録',
    'Enter your Username': 'ユーザー名を入力',
    'Enter your Password': 'パスワードを入力',
    'Forgot your password?': 'パスワードをお忘れですか？',
    // 必要に応じて他の文言も追加
    'Sign in': 'ログイン',
    'Sign Up with Google':'Googleアカウントで登録',
    'Username':'ユーザー名',
    'Enter your Phone Number':'電話番号を入力',
    'Password must have at least 8 characters':'パスワードは8文字以上である必要があります',
    'Password must have lower case letters':'パスワードには小文字が含まれている必要があります',
    'Password must have upper case letters':'パスワードには大文字が含まれている必要があります',
    'Password must have numbers':'パスワードには数字が含まれている必要があります'
  },
});
